import { isLoggedIn } from '../app/auth';

/** Routes that load with normal Suspense only — no workspace bootstrap shell. */
const PUBLIC_EXACT_PATHS = new Set([
  '/login',
  '/reset-password',
  '/verify-otp',
  '/force-password-change',
  '/event-invite',
  '/careers',
  '/unauthorized',
  '/forbidden',
]);

const PUBLIC_PATH_PREFIXES = [
  '/docsign/sign/',
  '/invitations/',
  '/recruitment/candidate/',
  '/app/diary/empowerment-submit-topic/',
];

function normalizeAppPath(pathname) {
  const raw = String(pathname || '').trim();
  const withoutQuery = raw.split('?')[0] || '/';
  const normalized = withoutQuery.replace(/\/+$/, '') || '/';
  return normalized;
}

/**
 * Current hash-router path (e.g. `/login`, `/docsign/sign/abc`).
 */
export function getInitialAppPath() {
  const hash = window.location.hash || '';
  const path = hash.startsWith('#') ? hash.slice(1) : hash;
  return normalizeAppPath(path || '/');
}

export function isPublicAppRoute(pathname) {
  const path = normalizeAppPath(pathname);
  if (PUBLIC_EXACT_PATHS.has(path)) return true;
  return PUBLIC_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
}

/**
 * Full workspace preload + BootstrapShell only for signed-in users on non-public routes.
 */
export function shouldRunAuthenticatedBootstrap(pathname = getInitialAppPath()) {
  if (!isLoggedIn()) return false;
  if (isPublicAppRoute(pathname)) return false;
  return true;
}
